import { Box, BoxProps, useTheme } from "@mui/material";
import { FC, ReactNode } from "react";

interface MyPaperProps extends BoxProps {
  children?: ReactNode;
}

const MyPaper: FC<MyPaperProps> = ({ children, ...props }) => {
  const theme = useTheme();

  return (
    <Box borderRadius="16px" p="16px" bgcolor={theme.myTheme.colors.tertiary} {...props}>
      {children}
    </Box>
  );
};

export default MyPaper;
